import { __extends } from "tslib";
import { Event } from './Event';
var NetDataEvent = /** @class */ (function (_super) {
    __extends(NetDataEvent, _super);
    function NetDataEvent(type, bubbles, cancelable, timestamp, info) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (timestamp === void 0) { timestamp = 0; }
        if (info === void 0) { info = null; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this.timestamp = +timestamp;
        _this.info = info;
        return _this;
    }
    NetDataEvent.classInitializer = null;
    NetDataEvent.classSymbols = null;
    NetDataEvent.instanceSymbols = null;
    // JS -> AS Bindings
    NetDataEvent.MEDIA_TYPE_DATA = 'mediaTypeData';
    return NetDataEvent;
}(Event));
export { NetDataEvent };
